import Styles from '@components/calendar/Calendar.scss';
import { Month } from '@components/calendar/month';
import { useUserEngagementInteractivity } from '@feature-flags/hooks/Storefront/useUserEngagementInteractivity';
import { usePricingSeasonal } from '@hooks/use-pricing-seasonal';
import { useSwipeHandler } from '@hooks/useSwipeHandler';
import { StatusBadge } from '@tkww/orion-web-ds-feedback';
import { Caption } from '@xo-union/tk-ui-typography';
import classNames from 'classnames';
import React from 'react';
import { useDayPicker } from 'react-day-picker';
import { months } from '../../routes/fetch/storefrontPage/utils/venuePricing/monthFormat';
import { useCalendarNavigation } from './hooks/useCalendarNavigation';

export const CalendarView = () => {
	const dayPicker = useDayPicker();
	const { handlePreviousClick, handleNextClick, navigation } =
		useCalendarNavigation();
	const calendarRef = useSwipeHandler(handleNextClick, handlePreviousClick);

	const userEngagementInteractivityAssignmentVariant =
		useUserEngagementInteractivity();

	const { peakMonths, offPeakMonths } = usePricingSeasonal();
	const currentMonthName = months[navigation.currentMonth.getMonth()];

	const isPeakSeason = peakMonths?.includes(currentMonthName);
	const isOffPeakSeason =
		!isPeakSeason && offPeakMonths?.includes(currentMonthName);

	return (
		<>
			<div
				id={dayPicker.id}
				className={classNames(Styles.calendar, {
					[Styles.twoMonths]: navigation.displayMonths.length === 2,
				})}
				ref={calendarRef}
			>
				{userEngagementInteractivityAssignmentVariant &&
					(isPeakSeason || isOffPeakSeason) && (
						<StatusBadge size="sm" styleType="informational">
							<Caption size="lg">
								{isPeakSeason ? 'Peak season' : 'Off-peak season'}
							</Caption>
						</StatusBadge>
					)}
				<Month idx={0} displayMonth={navigation.displayMonths[0]} />
				{navigation.displayMonths.length === 2 && (
					<Month idx={1} displayMonth={navigation.displayMonths[1]} />
				)}
			</div>
		</>
	);
};
